var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-col',{attrs:{"align-self":"center","sm":"6","offset-sm":"3"}},[_c('login-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }